"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionSubtype = exports.QuestionFamily = exports.VariableType = exports.PredicateOption = void 0;
var PredicateOption;
exports.PredicateOption = PredicateOption;
(function (PredicateOption) {
  PredicateOption["NoResponse"] = "noresponse";
  PredicateOption["Response"] = "response";
  PredicateOption["Equals"] = "equals";
  PredicateOption["NotEquals"] = "notequals";
  PredicateOption["Contains"] = "contains";
  PredicateOption["NotContains"] = "notcontains";
  PredicateOption["StartsWith"] = "startswith";
  PredicateOption["EndsWith"] = "endswith";
  PredicateOption["Greater"] = "greater";
  PredicateOption["GreaterEqual"] = "greaterequal";
  PredicateOption["Less"] = "less";
  PredicateOption["LessEqual"] = "lessequal";
  PredicateOption["IsOneOf"] = "isoneof";
  PredicateOption["IsNotOneOf"] = "notisoneof";
  PredicateOption["ContainsAnyOf"] = "containsanyof";
  PredicateOption["NotContainsAnyOf"] = "notcontainsanyof";
  PredicateOption["ContainsAllOf"] = "containsallof";
  PredicateOption["NotContainsAllOf"] = "notcontainsallof";
})(PredicateOption || (exports.PredicateOption = PredicateOption = {}));
var VariableType;
exports.VariableType = VariableType;
(function (VariableType) {
  VariableType["String"] = "string";
  VariableType["Number"] = "number";
  VariableType["Single"] = "single";
  VariableType["Multi"] = "multi";
})(VariableType || (exports.VariableType = VariableType = {}));
var QuestionFamily;
exports.QuestionFamily = QuestionFamily;
(function (QuestionFamily) {
  QuestionFamily["SingleChoice"] = "single_choice";
  QuestionFamily["MultipleChoice"] = "multiple_choice";
  QuestionFamily["OpenEnded"] = "open_ended";
  QuestionFamily["Demographic"] = "demographic";
  QuestionFamily["Matrix"] = "matrix";
})(QuestionFamily || (exports.QuestionFamily = QuestionFamily = {}));
var QuestionSubtype; // eslint-disable-next-line import/prefer-default-export

exports.QuestionSubtype = QuestionSubtype;
(function (QuestionSubtype) {
  QuestionSubtype["Single"] = "single";
  QuestionSubtype["Essay"] = "essay";
  QuestionSubtype["Multi"] = "multi";
  QuestionSubtype["Numerical"] = "numerical";
  QuestionSubtype["Rating"] = "rating";
  QuestionSubtype["Ranking"] = "ranking";
  QuestionSubtype["Menu"] = "menu";
})(QuestionSubtype || (exports.QuestionSubtype = QuestionSubtype = {}));